import React from "react";
import {IconButton, Tooltip} from "@mui/material";
import {DeviceFlat} from "../../../app/api/model/device";
import {useCancelFirmwareUpdate} from "../../../hooks/useCancelFirmwareUpdate";
import {useTranslation} from "react-i18next";
import UpdateDisabledIcon from "@mui/icons-material/UpdateDisabled";

const CancelFirmwareUpdateButton = (props: {devices: (DeviceFlat | undefined)[]}) => {
    const {t} = useTranslation();
    const {devices} = props;
    const {isActive, cancelFirmwareUpdate} = useCancelFirmwareUpdate({devices});
    return (
        <>
            {isActive && (
                <Tooltip title={t("action_cancelFirmwareUpdate")}>
                    <IconButton onClick={cancelFirmwareUpdate}>
                        <UpdateDisabledIcon />
                    </IconButton>
                </Tooltip>
            )}
        </>
    );
};

export default CancelFirmwareUpdateButton;
